export default "__VITE_ASSET__BGi113t8__"